import * as moment from "moment";

export function daysBetweenTwoDates(date1, date2) {
  date1 = new Date(date1);
  date2 = new Date(date2);

  const momentDate1 = moment(date1).startOf("day");
  const momentDate2 = moment(date2).startOf("day");

  return momentDate1.diff(momentDate2, "days");
}
